import React from 'react'
import Manager from '../../public/components/Manager'
import RequisitionDiv from './RequisitionDiv'
Ext.require('Ext.Toast')

const config = {
    buttons: [
    ],
    columns: [
        { _text: '请购单号', field: 'Number', minWidth: 150, search: true, flex: 1 },
        { _number: '支付金额', field: 'LCTaxAmount', minWidth: 150, flex: 1 },
        { _text: '申请部门', field: 'CreateDep', minWidth: 150, flex: 1 },
        { _text: '申请人', field: 'Creator', minWidth: 150, search: true, flex: 1 },
        { _date: '申请时间', field: 'CreateTime', minWidth: 150, flex: 1 },
    ],
    onDoubleTap: ({ showDetail, refreshPage }, data) => {
        showDetail(props => <RequisitionDiv {...props} id={data.id} onSave={refreshPage} />)
    }

}

export default props => <Manager {...props} config={config} />